import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
const styles = theme => ({
  root: {
    bottom: ({ isSelected }) => isSelected && theme.spacing(0.125),

    boxShadow: ({ isSelected }) => {
      return isSelected
        ? get(theme, 'boxShadows.MuiCard.selected')
        : get(theme, 'boxShadows.MuiCard.base');
    }
  }
});

const LocationsPaper = ({ isSelected, children, ...props }) => {
  return <Card {...props}>{children}</Card>;
};

LocationsPaper.propTypes = {
  isSelected: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default withStyles(styles)(LocationsPaper);
